import { render, staticRenderFns } from "./DoKoRestrictionSoloQ.vue?vue&type=template&id=2227066d&scoped=true&"
import script from "./DoKoRestrictionSoloQ.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionSoloQ.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionSoloQ.vue?vue&type=style&index=0&id=2227066d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227066d",
  null
  
)

export default component.exports